import { render, staticRenderFns } from "./AddBankStatementSidebar.vue?vue&type=template&id=00d9fa18&scoped=true&lang=html"
import script from "./AddBankStatementSidebar.vue?vue&type=script&lang=js"
export * from "./AddBankStatementSidebar.vue?vue&type=script&lang=js"
import style0 from "./AddBankStatementSidebar.vue?vue&type=style&index=0&id=00d9fa18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9fa18",
  null
  
)

export default component.exports